import { ReactNode } from 'react';

import Header from './Header';
import NavigationBar from './NavigationBar';
import Sidebar from './Sidebar';
import styles from './styles.module.scss';

interface Props {
    children: ReactNode;
}

function MainLayout({ children }:Props) {
  return (<div className={styles.container}>
        <Header/>
        <main className={styles.contents} data-scroll-restoration={true}>
            {children}
        </main>
        <NavigationBar/>
        <Sidebar/>
    </div>);
}

export default MainLayout;
